import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';

export const useLeftPaneStyles = makeStyles((theme: Theme) => ({
  root: {
    height: '100%',
    borderRight:
      theme.palette?.mode === 'dark'
        ? '1px solid var(--xlrt-color-ui-gray40)'
        : '1px solid var(--xlrt-color-ui-gray85)',
    transition: 'width 0.3s ease',
    backgroundColor:
      theme.palette?.mode === 'dark'
        ? 'var(--xlrt-color-ui-gray25)'
        : 'var(--xlrt-color-ui-white)',
    overflow: 'hidden',
    flexShrink: 0,
  },
  expanded: {
    width: '14.5rem',
  },
  collapsed: {
    width: '3.75rem',
  },
  sidebarWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
    flexShrink: 0,
  },
  sidebarInner: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden',
  },
  sidebarHeader: {
    display: 'flex',
    padding: '1rem',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom:
      theme.palette?.mode === 'dark'
        ? '1px solid var(--xlrt-color-ui-gray40)'
        : '1px solid var(--xlrt-color-ui-gray85)',
  },
  sidebarHeaderText: {
    color:
      theme.palette.mode === 'light'
        ? 'var(--xlrt-color-ui-gray20)'
        : 'var(--xlrt-color-ui-white)',
    fontSize: '1.5rem',
    fontWeight: 500,
    lineHeight: '133.333%',
    whiteSpace: 'nowrap',
  },
  chatItem: {
    borderRadius: '0.5rem',
    margin: '0.25rem 0.5rem',
    '&.Mui-selected': {
      backgroundColor: theme.palette.mode === 'dark' ? '#4D4D4D' : '#F0F1F2',
    },
  },
  chatIcon: {
    marginRight: '0.75rem',
    color:
      theme.palette.mode === 'dark'
        ? 'var(--xlrt-color-ui-gray60)'
        : 'var(--xlrt-color-ui-gray20)',
  },
  headerActions: {
    display: 'flex',
    padding: '0.188rem',
    alignItems: 'center',
    gap: '0.375rem',
  },
  headerIcon: {
    color:
      theme.palette?.mode === 'dark'
        ? 'var(--xlrt-color-ui-gray60)'
        : 'var(--xlrt-color-ui-gray20)',
  },
  collapsedContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: '1rem',
    gap: '1rem',
    color:
      theme.palette?.mode === 'dark'
        ? 'var(--xlrt-color-ui-gray60)'
        : 'var(--xlrt-color-ui-gray20)',
    '& .MuiIconButton-root, & .v5-MuiIconButton-root': {
      color: 'inherit',
    },
  },
  conversationHistory: {
    flex: 1,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
  newchat: {
    fontSize: '0.875rem',
  },
}));
